import React, { useEffect, useState } from "react";
import styles from "./dropdown.module.scss";
import SortIcon from "../../../assets/images/v2/sort-icon.svg";

export interface DropdownOption {
  readonly title: string;
  readonly isSelected?: boolean;
  readonly onSelected?: () => void;
}

export interface DropdownProps {
  readonly options: DropdownOption[];
  readonly disable: boolean
  readonly onSelection?: (option: DropdownOption) => void;
  readonly onToggleOrder?: () => void;
}

export const Dropdown: React.FC<DropdownProps> = ({options, disable, onSelection, onToggleOrder}) => {
  const [ displayOptionsState, setDisplayOptionsState ] = useState(false);
  const toggleDisplayOptions = () => {
    setDisplayOptionsState(!displayOptionsState);
  }

  const [selectedOption, setSelectedOption] = useState<DropdownOption>(options[0]);

  const handleOptionSelected = (option: DropdownOption) => {
    onSelection?.(option);
    option.onSelected?.();
    setSelectedOption(option);
    toggleDisplayOptions();
  };

  useEffect(() => {
    setSelectedOption(options.find(o => o.isSelected) || options[0]);
  }, [options])

  return (
    <div className={styles.container}>
      <div className={`${styles["top-row"]} ${disable ? styles["dropdown-disabled"] : ""}`}>
        <button className={`${styles["icon-container"]} ${disable ? styles["dropdown-disabled"] : ""}`} disabled={disable}
          onClick={() => onToggleOrder?.()}>
          <img alt="two vertical arrows pointing in opposite directions" src={SortIcon} />
        </button>
        <button
          type="button"
          className={`${styles["selected-option"]} label-large-regular`}
          disabled={disable}
          onClick={toggleDisplayOptions}
          onKeyDown={(e) => {
            if (disable) return;
            if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  toggleDisplayOptions();
                }
          }}
        >
          {selectedOption.title}
        </button>
      </div>
      {!disable && displayOptionsState && (
        <div className={styles["options-container"]}>
          {options.map((option, optionIndex) =>
            {
              const optionClassName = `label-large-${options.indexOf(selectedOption) === optionIndex ? "semibold" : "regular"}`;
              return (
                <button
                  className={styles["option-container"]}
                  onClick={() => handleOptionSelected(option)}
                  key={option.title}>
                  <span className={optionClassName}>{option.title}</span>
                </button>
              );
            }
            )}
        </div>
      )}
    </div>
  );
};